import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, forwardRef } from "react";
import Icon from "../../Icon/Icon";
var VkLogoIcon = /*#__PURE__*/forwardRef(function (properties, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("path", {
    d: "M12.893 18.5C6.06 18.5 2.163 13.808 2 6h3.423c.112 5.73 2.636 8.158 4.634 8.659V6h3.223v4.942c1.974-.212 4.048-2.465 4.747-4.942h3.223c-.537 3.053-2.785 5.305-4.384 6.231 1.599.751 4.16 2.715 5.134 6.269h-3.548c-.762-2.377-2.66-4.217-5.172-4.467V18.5h-.387z",
    fill: "currentColor"
  }));
});
export default /*#__PURE__*/memo(VkLogoIcon);